export default (function (_ref) {
  var colors = _ref.colors;
  return {
    label: {
      color: colors.black
    },
    value: {
      color: colors.black
    }
  };
});